























































































































































































































































































































































































































	import _, { assign } from "lodash";
	import { UIModel } from "../UIModel";
	import { FrontendBIM360Issue } from "../model/frontend/FrontendBIM360Issue";
	import { Prop, Component, Vue, Watch } from "vue-property-decorator";
	import { BIM360IssueStatus, BIM360Issue } from "../model/BIM360Issue";
	import { FrontendForgeUser } from "@/model/frontend/FrontendForgeUser";
	import * as moment from "moment";
	import { SettingsHub } from '@/model/frontend/FrontendSettings';
	import { SocketIOClient } from "../util/SocketIOClient";
	import { FrontendProjectRolesJobMessage } from './../model/frontend/FrontendProjectRolesJobMessage';
	import { BackendACCRole } from './../model/backend/BackendACCRole';
	import { FrontendUserLicense } from '../model/frontend/FrontendUserLicense';
	import { FrontendRegisteredWebhook } from "@/model/frontend/FrontendRegisteredWebhook";
	import { ERegion } from "@/model/ERegion";
	@Component
	export default class Settings extends Vue {
		// Props
		@Prop({ required: true }) public model!: UIModel;

		public issue_role = null;
		public model_role = null;
		public checkedRows: any[] = [];
		public isLoading: boolean = false;
		public selected_hubs: SettingsHub[] = [];
		public selected_hubs_copy: SettingsHub[] = [];
		private refreshLoadingCount = 4;
		private socketIOClient!: SocketIOClient;
		public accProjectRolesSyncStatus = {};
		public addingEmail = false;
		public emailInput = "";
		public filteredACCRoles: BackendACCRole[]= [];

		public domainInput = "";
		public addingDomain = false;

		public selectedWebhookProject: any = null;
		public selectedWebhookFolder: any = null;
		public webhookFolders: any[] = [];
		public loadingWebhookFolders = false;
		public registeringWebhook = false;
 		public registeredWebhooks: FrontendRegisteredWebhook[] = [];
		public deletingWebhookId: string | null = null;

		public get webhookAlreadyRegisteredForFolder(): boolean {
			if (!this.selectedWebhookProject || !this.selectedWebhookFolder) return false;
			const projectId = this.selectedWebhookProject.id;
			const folderName = this.selectedWebhookFolder.attributes?.displayName || this.selectedWebhookFolder.attributes?.name || "";
			return this.registeredWebhooks.some(
				w => w.autodeskProjectId === projectId && w.folderName === folderName
			);
		}

		@Watch('model.selectHubLoading')
		public async onSelectHubLoadingChanged(selectHubLoading: boolean) {
			if (!selectHubLoading && this.model.selectedHub) {
				await this.load();		
			}
		}

		public async loadWebhooks(): Promise<void> {
			if (this.model.selectedHub) {
				const resp = await this.model.getRegisteredWebhooks(this.model.selectedHub?.region as ERegion);
				this.registeredWebhooks = resp.registeredWebhooks.filter(
					w => w.autodeskAccountId == this.model.accountID && 
					w.isProjectAccess && 
					w.env == process.env.NODE_ENV
				);
			}
		}

		public syncStatus(hub: SettingsHub, entity: string) {
			if(this.accProjectRolesSyncing(String(hub.id))) {
				return `${entity} Syncing`;
			}
			if(!hub.accProjectRolesList.length) {
				return  `${entity} not Synced`
			}
			return  `${entity} Synced`
		}

		public isSelectedProjectAdmin(hub) {
			return hub.defaultBIM360ProjectServices.services.find(s => s.name === "project_administration")?.access_level === "admin";
		}

		public handleBIM360ServiceAccessChange(hub, row: {name: string, access_level: string}): void {
			if (row.name === "project_administration" && row.access_level === "admin") {
				const docService = hub.defaultBIM360ProjectServices.services.find(s => s.name === "document_management");
				if (docService) {
					docService.access_level = "admin";
					console.log("hub.defaultBIM360ProjectServices.services!!!!", hub.defaultBIM360ProjectServices.services)
				}
			}
		}

		public get isEmailValid() {
			return /\S+@\S+\.\S+/.test(this.emailInput); // Checks if email format is valid
		}

		public get isDomainValid() {
			return /\S+\.\S+/.test(this.domainInput);
		}

		public async removeEmail(email) {
			this.model.settings.hubs[0].ccEmails = this.model.settings.hubs[0].ccEmails.filter(e => e != email);
		}

		public async removeDomain(domain) {
			this.model.settings.hubs[0].allowedDomains = this.model.settings.hubs[0].allowedDomains.filter(e => e != domain);
		}

		public async addEmail() {
			this.addingEmail = true;
			if (this.emailInput && !this.model.settings.hubs[0].ccEmails.includes(this.emailInput)) {
				this.model.settings.hubs[0].ccEmails.push(this.emailInput);
			}
			this.addingEmail = false;
			this.emailInput = "";
		}

		public async addDomain() {
			this.addingDomain = true;
			if (this.domainInput && !this.model.settings.hubs[0].allowedDomains.includes(this.domainInput)) {
				this.model.settings.hubs[0].allowedDomains.push(this.domainInput);
			}
			this.addingDomain = false;
			this.domainInput = "";
		}

		public getFilteredRole(value: string) {
			this.filteredACCRoles =this.model.settings.hubs[0]?.accProjectRolesList?.filter((r) => {
				return r.name
					.toString()
					.toLowerCase()
					.indexOf(value.toLowerCase()) >= 0
			});
		}


		public visibleRoles(accProjectRolesList: string[]) {
			return accProjectRolesList
					.map((role: string) => ({ name: role }))
					.slice(0, 5);
		}

		get hubs() {
			return this.model.settings.hubs
		}

		// Getters
		get roles(): any[] {
			if (this.model.settings.hubs.length > 1) {
				let role_arrays: any[] = [];
				for (let hub of this.model.settings.hubs) {
					role_arrays.push(hub.roles);
				}
				let output = _.intersection(...role_arrays);
				console.log(output);
				return output;
			} else {
				return [...this.model.settings.hubs[0].roles].sort((a, b) => String(a.name).localeCompare( String(b.name)));
			}
		}

		public accProjectRolesSyncing(hubID: string): boolean {
			if(!this.getAccProjectRolesSyncStatus(hubID)) return false;
			else if(this.getAccProjectRolesSyncStatus(hubID) == "failed") return false;
			else if(this.getAccProjectRolesSyncStatus(hubID) == "complete") return false;
			return true;
		}

		public getAccProjectRolesSyncStatus(hubID: string) {
			if(this.accProjectRolesSyncStatus[hubID] == undefined) 
			{
				Vue.set(this.accProjectRolesSyncStatus, hubID, "");
			}
			return this.accProjectRolesSyncStatus[hubID];
		}

		public async created()
		{
			if(this.model.selectedHub && !this.model.selectHubLoading) {
				await this.model.getUserAccessInfo();
				await this.load();				
			}
		}

		async syncACCProjectRoles(hubID: string) {
			try {
				Vue.set(this.accProjectRolesSyncStatus, hubID, "pending");
				await this.model.syncACCProjectRolesList();
			} catch (error) {
				Vue.set(this.accProjectRolesSyncStatus, hubID, "");
				console.error("Error fetching project roles:", error);
			}
		}
		
		public getProjectRoles(projectId) {
			if(!this.model.selectedHub) return [];
			if(!this.model.settings.hubs.length) return [];
			const theHubSetting = this.model.settings.hubs.find(h => h.id == this.model.selectedHub?.id);
			return theHubSetting?.roles.filter(r => r.projectId == projectId)
		}

		// Created
		async load() {
			this.isLoading = true;
			console.log("settings created");
			await this.model.getUserEntitlements();
			await this.model.getHubRolesIntersection();
			await this.loadWebhooks();
			this.isLoading = false;
			if (!this.model.settings.is_allowed) {
				this.$router.push("/issues");
			}

			if(this.hasProjectlistLisense())
			{
				this.socketIOClientInit();
			}
		}

		public async onWebhookProjectChange(project: any) {
			this.selectedWebhookFolder = null;
			this.webhookFolders = [];
			if (project && project.hubId && project.id) {
				this.loadingWebhookFolders = true;
				await this.model.getProjectFolders(project.hubId, project.id);
				const topFolders = this.model.projectFolders.data;
				if (topFolders && topFolders.length > 0) {
					// Take the first top folder (typically "Project Files")
					const topFolder = topFolders[0];
					this.webhookFolders = await this.model.getProjectFolderContents(project.id, topFolder.id);
				}
				this.loadingWebhookFolders = false;
			}
		}

		public async deleteWebhook(webhook: FrontendRegisteredWebhook): Promise<void> {
			this.deletingWebhookId = webhook.hookId;
			try {
				const region = this.model.selectedHub?.region as ERegion;
				await this.model.deleteWebhook(webhook.hookId, region);
				this.registeredWebhooks = this.registeredWebhooks.filter(w => w.hookId !== webhook.hookId);
				this.snackbar("Webhook deleted successfully!", "OK", "is-success");
			} catch (error) {
				this.snackbar("Failed to delete webhook", "OK", "is-danger");
			} finally {
				this.deletingWebhookId = null;
			}
		}

		public async registerWebhookForProjectAccess(): Promise<void> {
			if (!this.selectedWebhookProject || !this.selectedWebhookFolder || !this.model.accountID) return;
			this.registeringWebhook = true;
			try {
				const project = this.selectedWebhookProject;
				const folder = this.selectedWebhookFolder;
				console.log("registerWebhookForProjectAccess: ", folder);
				const accountID = this.model.accountID;
				const projectID = project.id;
				const projectName = project.name;
				const folderName = folder.attributes?.displayName || folder.attributes?.name || "";
				const region = this.model.selectedHub?.region as ERegion || "US";

				// Delete any existing webhook for this project before registering a new one
				const existing = this.registeredWebhooks.find(w => w.autodeskProjectId === projectID);
				if (existing) {
					console.log("Deleting existing webhook for project:", existing.hookId, "folder:", existing.folderName);
					await this.model.deleteWebhook(existing.hookId, region as ERegion);
				}
				
				await this.model.registerWebhookForProjectAccess(
					region,
					folder.id,
					accountID,
					projectID,
					projectName,
					folderName
				);
				this.snackbar("Webhook registered successfully!", "OK", "is-success");
				const resp = await this.model.getRegisteredWebhooks(this.model.selectedHub?.region as ERegion);
				this.registeredWebhooks = resp.registeredWebhooks.filter(w => w.autodeskAccountId == this.model.accountID && w.isProjectAccess && w.env == process.env.NODE_ENV);
			} catch (error) {
				console.error("Failed to register webhook:", error);
				this.snackbar("Failed to register webhook", "OK", "is-danger");
			} finally {
				this.registeringWebhook = false;
			}
		}

		public async save(
			{ isProjectAccess = false }: { isProjectAccess?: boolean } = {}
		): Promise<void> {
			if(isProjectAccess) {
				const projectProductCode = String(process.env.VUE_APP_PROJECT_LIST_PRODUCT_CODE ?? "");
				const license = this.model?.settings?.licenses.find(license => license?.product_code === projectProductCode);
				if(!this.model.canSaveProjectAccess(license, String(this.model.selectedHub?.id))) {
					this.snackbar("The number of hubs exceeds the number of licensed seats.", "OK", "is-info");
					return 
				}
			}
			await this.model.uploadSettings();
			this.snackbar("Saved changes!", "Sweet", "is-success");
		}

		public changesValid(hub: any): boolean {
			const issueModuleEnabled = hub.projects.find((project: any) => project.issueModuleEnabled);
			const coordinateModuleEnabled = hub.projects.find((project: any) => project.coordinateModuleEnabled);
			const docSyncModuleEnabled = hub.projects.find((project: any) => project.docSyncModuleEnabled);
			if(!issueModuleEnabled && !coordinateModuleEnabled && !docSyncModuleEnabled) return false;
			if (!hub.issueModuleRole && !hub.coordinateModuleRole && !hub.docSyncModuleRole) {
				return false;
			} 

			return true;
		}


		public projListModuleChangesValid(hub: any): boolean {
			if(hub.projectListModuleRole)
				return true;
			return false;
		}

		public snackbar(message: string, actionText: string, type: string) {
			this.$buefy.snackbar.open({
				indefinite: true,
				message: message,
				actionText: actionText,
				type: type,
				position: "is-bottom-right",
				queue: false
			});
		}

		public getHubName(id: string): string 
		{
			if(this.model.hubs.data)
			{
				const h = this.model.hubs.data.find(h => h.id == id);
				if(h)return h.name;
			}
			return "";
		}

		public getProjectName(id: string): string 
		{
			if(this.model.projects.data)
			{
				const p = this.model.projects.data.find(p => p.id == id);
				if(p)return p.name;
			}
			return "";
		}

		public getRoleNames(userLicense: FrontendUserLicense) {
			if(userLicense.roleName) return userLicense.roleName;
			return userLicense.allowedRoles.map(r => r.name).join(', ');
		}

		public hasProjectlistLisense(): boolean {
			const found = this.model.settings.licenses.find(l => l.product_code == process.env.VUE_APP_PROJECT_LIST_PRODUCT_CODE);
			if(found) return true;
			return false;
		}

		private socketIOClientInit() {
			this.socketIOClient = SocketIOClient.getInstance();
			const hubID = this.model.selectedHub?.id;
			if(hubID) {
				this.socketIOClient.subscribeToHubIDTopic({ hubID: hubID });
				this.socketIOClient.addHandler(FrontendProjectRolesJobMessage, (data => {
					console.log("FrontendProjectRolesJobMessage: ", data);
					Vue.set(this.accProjectRolesSyncStatus, hubID, data.status);
					if(data.roles.length)
					{
						this.model.setAccProjectRolesForHub(`b.${data.accountID}`, data.roles, data.usersWithRoles, data.companies);
					}
				}));
			}
    	}

		public showOtherModuleSettings() {
			const found = this.model.settings.licenses.find(l => 
				l.product_code != process.env.VUE_APP_PROJECT_LIST_PRODUCT_CODE
			);
			if(found) return true;
			return false;
		}

		public getSortedCompanies(hub: SettingsHub) {
			return [...hub.companies].sort((a, b) => a.name.localeCompare(b.name));
		}

		public sortUsersByEmail(users: FrontendForgeUser[]) {
			return [...users].sort((a, b) => a.email.localeCompare(b.email));
		}

		public getSeatsInUse(license: FrontendUserLicense) {
			return license?.allowedUsers?.length
		}
	}
